import type { TvShow } from "@/types/media";

export const tvs: TvShow[] = [
  {
    id: "t-001",
    title: "苍穹之巅",
    year: 2024,
    country: "中国大陆",
    director: "孔笙",
    actors: ["王凯", "谭卓", "张新成"],
    genres: ["科幻", "悬疑", "剧情"],
    rating: 8.9,
    poster:
      "https://readdy.ai/api/search-image?query=sci-fi%20tv%20series%20poster%2C%20futuristic%20skyscraper%20city%20under%20storm%20with%20lightning%2C%20deep%20navy%20and%20cyan%20glow%2C%20epic%20cinematic%20vertical%20key%20art%2C%20high%20detail&width=600&height=900&seq=tv-poster-001&orientation=portrait",
    description:
      "在一座悬浮于云层之上的未来都市里，能源垄断集团与反抗者之间的博弈愈演愈烈。一名普通工程师意外掌握了足以颠覆秩序的核心机密，必须在追杀中寻找真相。",
    updatedAt: "2024-10-14",
    episodeCount: 24,
    updatedTo: 12,
    episodes: [
      { no: 1, title: "云层之上", summary: "工程师林澈在例行检修中发现了悬浮城的能源异常，命运的齿轮开始转动。" },
      { no: 2, title: "异常数据", summary: "一组不该存在的数据出现在系统中，林澈意识到自己窥见了不该看的东西。" },
      { no: 3, title: "失踪的同事", summary: "与他共同发现异常的老同事突然失踪，公司给出的解释漏洞百出。" },
      { no: 4, title: "地下层", summary: "林澈循着线索潜入被封锁的地下能源层，见到了悬浮城真实的模样。" },
      { no: 5, title: "反抗者", summary: "一个自称“苍穹”的神秘组织主动联系了他，提出的条件却让他犹豫。" },
      { no: 6, title: "追捕", summary: "公司安全部门开始全面排查，林澈不得不在熟悉又陌生的城市中逃亡。" },
      { no: 7, title: "旧照片", summary: "母亲留下的一张旧照片，牵出了二十年前那场被掩盖的事故。" },
      { no: 8, title: "交易", summary: "为了换取保护，林澈被迫交出手中的证据，却发现对方另有图谋。" },
      { no: 9, title: "断网时刻", summary: "悬浮城突发大规模断网，混乱之中各方势力同时行动。" },
      { no: 10, title: "真相的一角", summary: "能源危机的真正原因浮出水面，整个城市的存亡都被绑在了一起。" },
      { no: 11, title: "同盟", summary: "曾经的对手选择联手，一场针对垄断集团的计划悄然展开。" },
      { no: 12, title: "苍穹之巅", summary: "林澈终于站在了悬浮城最高处，而等待他的选择，关乎所有人的命运。" },
    ],
  },
  {
    id: "t-002",
    title: "长安十二时辰",
    year: 2023,
    country: "中国大陆",
    director: "曹盾",
    actors: ["雷佳音", "易烊千玺", "周一围"],
    genres: ["古装", "悬疑", "历史"],
    rating: 8.7,
    poster:
      "https://readdy.ai/api/search-image?query=ancient%20chinese%20historical%20mystery%20tv%20poster%2C%20tang%20dynasty%20city%20gate%20at%20dawn%20with%20lanterns%20and%20fog%2C%20deep%20blue%20and%20crimson%20accent%20palette%2C%20epic%20cinematic%20vertical%20key%20art%2C%20high%20detail&width=600&height=900&seq=tv-poster-002&orientation=portrait",
    description:
      "上元节前夕，长安城陷入一场精心策划的危机。一名死囚与一位少年天才在十二个时辰内联手查案，誓要在灯会开始前阻止灾难的发生。",
    updatedAt: "2024-10-11",
    episodeCount: 24,
    updatedTo: 24,
    episodes: [
      { no: 1, title: "长安暗涌", summary: "上元节将至，长安城暗流涌动，一桩密报让全城进入戒备。" },
      { no: 2, title: "死囚出笼", summary: "为破奇案，官府不得不启用一名身陷囹圄的死囚。" },
      { no: 3, title: "少年司丞", summary: "天才少年李必与死囚张小敬组成临时的搭档。" },
      { no: 4, title: "狼卫密谋", summary: "线索指向一伙潜入城中的秘密组织，时间正在流逝。" },
      { no: 5, title: "坊市追踪", summary: "两人深入坊市追查火源，却屡屡与真相擦肩而过。" },
      { no: 6, title: "暗桩", summary: "城中的内应浮出水面，信任变得格外奢侈。" },
    ],
  },
  {
    id: "t-003",
    title: "都市温度",
    year: 2024,
    country: "中国大陆",
    director: "滕华涛",
    actors: ["海清", "张颂文", "白百何"],
    genres: ["都市", "情感", "剧情"],
    rating: 8.1,
    poster:
      "https://readdy.ai/api/search-image?query=modern%20urban%20drama%20tv%20poster%2C%20cozy%20apartment%20windows%20glowing%20at%20night%20over%20city%2C%20warm%20amber%20light%20against%20deep%20blue%20sky%2C%20intimate%20cinematic%20mood%2C%20high%20detail&width=600&height=900&seq=tv-poster-003&orientation=portrait",
    description:
      "一栋老小区里住着形形色色的普通人，外卖员、医生、退休教师与年轻创业者的生活彼此交叠。在钢筋水泥的城市里，他们用善意维系着人与人之间最后的温度。",
    updatedAt: "2024-10-13",
    episodeCount: 20,
    updatedTo: 9,
    episodes: [
      { no: 1, title: "搬来的邻居", summary: "新婚夫妻搬进老小区，与邻里间的第一次照面充满误会。" },
      { no: 2, title: "深夜外卖", summary: "外卖员小陈的一次送餐，意外改变了一户人家的一天。" },
      { no: 3, title: "楼道里的灯", summary: "一盏常年失修的楼道灯，成为邻里之间的小小纽带。" },
      { no: 4, title: "体检报告", summary: "退休教师拿到一份体检报告，开始重新审视自己的生活。" },
      { no: 5, title: "创业的夜", summary: "年轻创业者的项目濒临失败，邻居们用各自的方式伸出援手。" },
      { no: 6, title: "雨夜送医", summary: "一场突发疾病，让整栋楼的人们第一次真正站在一起。" },
      { no: 7, title: "旧照片", summary: "整理旧物时发现的老照片，勾起了小区几十年的记忆。" },
      { no: 8, title: "误会", summary: "一次善意的隐瞒引发了误会，让一对邻里陷入冷战。" },
      { no: 9, title: "温度", summary: "当冬天真正来临，人们终于明白，温暖来自彼此。" },
    ],
  },
  {
    id: "t-004",
    title: "罪案档案",
    year: 2023,
    country: "美国",
    director: "大卫·芬奇",
    actors: ["杰克·吉伦哈尔", "玛格特·罗比", "马赫沙拉·阿里"],
    genres: ["犯罪", "悬疑", "惊悚"],
    rating: 8.6,
    poster:
      "https://readdy.ai/api/search-image?query=crime%20thriller%20tv%20series%20poster%2C%20detective%20pinning%20photos%20on%20a%20dim%20investigation%20board%2C%20deep%20blue%20and%20grey%20palette%2C%20tense%20noir%20cinematic%20mood%2C%20high%20detail&width=600&height=900&seq=tv-poster-004&orientation=portrait",
    description:
      "联邦调查局重案组接手了一桩沉寂十年的连环悬案。随着尘封档案被重新打开，调查员们发现凶手留下的线索，其实一直指向体制内部的某个人。",
    updatedAt: "2024-10-09",
    episodeCount: 18,
    updatedTo: 15,
    episodes: [
      { no: 1, title: "重启", summary: "一份新证据让尘封十年的档案重新回到案头。" },
      { no: 2, title: "第一张照片", summary: "凶手留下的第一张照片，隐藏着只有内行才懂的细节。" },
      { no: 3, title: "证人", summary: "唯一幸存的证人出现，却对当年的事闭口不谈。" },
      { no: 4, title: "内部", summary: "调查方向开始转向体制内部，阻力随之而来。" },
      { no: 5, title: "模式", summary: "作案模式逐渐清晰，指向一个被刻意忽略的时间节点。" },
      { no: 6, title: "旧案重启", summary: "更多相似案件被并入调查，真相远比想象庞大。" },
      { no: 7, title: "信任危机", summary: "小组内部出现分歧，搭档之间的信任受到考验。" },
      { no: 8, title: "迷雾", summary: "一条看似无关的线索，让案件陷入新的迷雾。" },
    ],
  },
  {
    id: "t-005",
    title: "王朝风云",
    year: 2022,
    country: "英国",
    director: "彼得·摩根",
    actors: ["克莱尔·福伊", "马特·史密斯", "海伦娜·伯翰·卡特"],
    genres: ["历史", "战争", "剧情"],
    rating: 8.8,
    poster:
      "https://readdy.ai/api/search-image?query=royal%20historical%20drama%20tv%20poster%2C%20majestic%20throne%20room%20with%20a%20crown%20on%20velvet%20cushion%2C%20deep%20blue%20and%20gold%20palette%2C%20regal%20cinematic%20mood%2C%20high%20detail&width=600&height=900&seq=tv-poster-005&orientation=portrait",
    description:
      "从加冕到战火，一个古老王室在时代巨变中艰难前行。权力、亲情与责任的拉扯下，每一位君主都必须为自己的选择付出代价。",
    updatedAt: "2024-10-06",
    episodeCount: 16,
    updatedTo: 16,
    episodes: [
      { no: 1, title: "加冕", summary: "年轻的君主在众人的注视下接过王冠，也接过了无形的重担。" },
      { no: 2, title: "顾问团", summary: "新旧势力的博弈，在第一次御前会议上便已开始。" },
      { no: 3, title: "联姻", summary: "一场被安排的政治婚姻，埋下了多年后的隐患。" },
      { no: 4, title: "远方的战报", summary: "边境的冲突让整个宫廷陷入紧张。" },
      { no: 5, title: "分裂", summary: "内阁出现公开分歧，王朝的根基开始动摇。" },
      { no: 6, title: "退位风波", summary: "一个关于退位的传闻，搅动了所有人的心思。" },
    ],
  },
  {
    id: "t-006",
    title: "我们的青春纪事",
    year: 2023,
    country: "中国大陆",
    director: "沙漠",
    actors: ["周迅", "白宇", "张婧仪"],
    genres: ["青春", "校园", "剧情"],
    rating: 8.3,
    poster:
      "https://readdy.ai/api/search-image?query=nostalgic%20youth%20campus%20tv%20poster%2C%20classroom%20window%20with%20sunlight%20and%20floating%20dust%2C%20warm%20golden%20tone%20with%20deep%20blue%20shadows%2C%20bittersweet%20cinematic%20mood%2C%20high%20detail&width=600&height=900&seq=tv-poster-006&orientation=portrait",
    description:
      "镜头回到千禧年前后的一所县城中学，五个性格迥异的少年在高考、离别与懵懂的情感中，一起走过了人生中最明亮也最珍贵的三年。",
    updatedAt: "2024-10-04",
    episodeCount: 24,
    updatedTo: 20,
    episodes: [
      { no: 1, title: "开学那天", summary: "新生报到，五个人的命运在同一个教室交汇。" },
      { no: 2, title: "同桌", summary: "一次调座，让原本陌生的人成了彼此最重要的陪伴。" },
      { no: 3, title: "运动会", summary: "一场接力赛，点燃了整个班级的荣誉感。" },
      { no: 4, title: "月考试卷", summary: "成绩公布的那天，有人欢笑有人落泪。" },
      { no: 5, title: "信", summary: "一封没有署名的信，在青春里埋下了秘密。" },
      { no: 6, title: "毕业倒计时", summary: "黑板上的倒计时开始，离别的气息悄然弥漫。" },
    ],
  },
  {
    id: "t-007",
    title: "医者仁心",
    year: 2024,
    country: "中国大陆",
    director: "张黎",
    actors: ["靳东", "殷桃", "王阳"],
    genres: ["职场", "剧情", "医疗"],
    rating: 8.0,
    poster:
      "https://readdy.ai/api/search-image?query=medical%20drama%20tv%20poster%2C%20surgeon%20silhouette%20in%20bright%20hospital%20corridor%20at%20dawn%2C%20clean%20blue%20and%20white%20palette%20with%20warm%20accent%2C%20hopeful%20cinematic%20mood%2C%20high%20detail&width=600&height=900&seq=tv-poster-007&orientation=portrait",
    description:
      "急诊科的一群医生在日常的生死时速中直面职业与生活。他们救死扶伤，也在一次次抉择中叩问：什么才是真正的医者仁心。",
    updatedAt: "2024-10-12",
    episodeCount: 20,
    updatedTo: 11,
    episodes: [
      { no: 1, title: "急诊夜", summary: "新任主治医师的第一个夜班，就迎来一台高难度手术。" },
      { no: 2, title: "家属签字", summary: "一张迟迟不肯签下的同意书，考验着医生与家属的信任。" },
      { no: 3, title: "会诊", summary: "多科室会诊中，专业判断与人文关怀产生了分歧。" },
      { no: 4, title: "疑难病例", summary: "一个罕见病例让整个团队连轴转了两天两夜。" },
      { no: 5, title: "走廊尽头的灯", summary: "深夜的走廊里，医生们讨论着白天没能救回的病人。" },
      { no: 6, title: "值班表", summary: "排班冲突背后，是每个人各自难以言说的难处。" },
    ],
  },
  {
    id: "t-008",
    title: "迷雾小镇",
    year: 2022,
    country: "美国",
    director: "M·奈特·沙马兰",
    actors: ["伊桑·霍克", "丽贝卡·弗格森", "杰瑞米·雷纳"],
    genres: ["悬疑", "惊悚", "奇幻"],
    rating: 8.2,
    poster:
      "https://readdy.ai/api/search-image?query=mysterious%20small%20town%20thriller%20tv%20poster%2C%20abandoned%20houses%20swallowed%20by%20dense%20fog%2C%20eerie%20deep%20blue%20and%20grey%20palette%2C%20haunting%20cinematic%20mood%2C%20high%20detail&width=600&height=900&seq=tv-poster-008&orientation=portrait",
    description:
      "一个被永久浓雾笼罩的小镇，居民们早已习惯了与世隔绝的生活。直到某天有人从雾中带回了一个不该存在的消息，整个小镇的秘密开始崩塌。",
    updatedAt: "2024-09-29",
    episodeCount: 12,
    updatedTo: 12,
    episodes: [
      { no: 1, title: "雾来了", summary: "小镇被浓雾封锁的第一天，没有人知道这会持续多久。" },
      { no: 2, title: "失踪者", summary: "一名居民踏进雾中，再没有回来。" },
      { no: 3, title: "无线电", summary: "一段奇怪的无线电信号，打破了小镇多年的沉默。" },
      { no: 4, title: "旧地图", summary: "图书馆里的旧地图，标注着雾深处不该有的地方。" },
      { no: 5, title: "外来者", summary: "一个从雾里走出的陌生人，带来了令人不安的预言。" },
      { no: 6, title: "真相边缘", summary: "当雾开始退去，居民们才意识到真正的危险才刚刚开始。" },
    ],
  },
  {
    id: "t-009",
    title: "家族纷争",
    year: 2021,
    country: "韩国",
    director: "朴赞郁",
    actors: ["李秉宪", "孙艺珍", "崔岷植"],
    genres: ["家庭", "剧情", "悬疑"],
    rating: 8.5,
    poster:
      "https://readdy.ai/api/search-image?query=dramatic%20family%20succession%20tv%20poster%2C%20long%20formal%20dining%20table%20in%20dim%20mansion%20hall%2C%20deep%20blue%20and%20burgundy%20palette%2C%20tense%20cinematic%20mood%2C%20high%20detail&width=600&height=900&seq=tv-poster-009&orientation=portrait",
    description:
      "掌管庞大企业集团的老会长突然病倒，三个子女围绕继承权展开明争暗斗。血缘与利益交织，家族的裂痕在餐桌上被一寸寸撕开。",
    updatedAt: "2024-09-22",
    episodeCount: 16,
    updatedTo: 16,
    episodes: [
      { no: 1, title: "家宴", summary: "一年一度的家族晚宴，气氛却比往年更加凝重。" },
      { no: 2, title: "遗嘱", summary: "老会长的病情恶化，一份尚未公开的遗嘱成为焦点。" },
      { no: 3, title: "长子", summary: "长子竭力维系体面，却发现自己早已被排除在外。" },
      { no: 4, title: "次女", summary: "一直被低估的次女，悄然布下了自己的棋局。" },
      { no: 5, title: "幼子归来", summary: "多年未归的幼子突然出现，搅动了原本的平衡。" },
      { no: 6, title: "裂痕", summary: "一场董事会的表决，让家族彻底走向分裂。" },
    ],
  },
  {
    id: "t-010",
    title: "星际学院",
    year: 2024,
    country: "美国",
    director: "J·J·艾布拉姆斯",
    actors: ["汤姆·赫兰德", "赞达亚", "塞缪尔·杰克逊"],
    genres: ["科幻", "青春", "冒险"],
    rating: 7.9,
    poster:
      "https://readdy.ai/api/search-image?query=sci-fi%20academy%20tv%20poster%2C%20young%20cadets%20in%20uniform%20before%20a%20giant%20spaceship%20hangar%2C%20deep%20blue%20and%20cyan%20lighting%2C%20adventurous%20cinematic%20mood%2C%20high%20detail&width=600&height=900&seq=tv-poster-010&orientation=portrait",
    description:
      "在银河系最负盛名的星际学院里，一群来自不同星球的年轻学员接受最严苛的训练。当一场真实的危机降临，他们必须证明自己不只是演习场上的天才。",
    updatedAt: "2024-10-10",
    episodeCount: 22,
    updatedTo: 10,
    episodes: [
      { no: 1, title: "入学", summary: "来自不同星球的学员在同一艘运输舰上初次相遇。" },
      { no: 2, title: "分班", summary: "分班测试的结果，让一些人欢喜，也让一些人不服。" },
      { no: 3, title: "第一次飞行", summary: "模拟飞行训练中，一次大胆的操作引发了争议。" },
      { no: 4, title: "夜间演习", summary: "夜间演习突发意外，学员们第一次体会到真正的危险。" },
      { no: 5, title: "竞争", summary: "学院内部的竞争逐渐升温，友谊面临考验。" },
      { no: 6, title: "实战警报", summary: "真正的警报拉响，学院进入了战备状态。" },
    ],
  },
  {
    id: "t-011",
    title: "山河故人",
    year: 2023,
    country: "中国大陆",
    director: "张艺谋",
    actors: ["于和伟", "张国立", "宋佳"],
    genres: ["年代", "剧情", "历史"],
    rating: 8.6,
    poster:
      "https://readdy.ai/api/search-image?query=epic%20period%20drama%20tv%20poster%2C%20old%20chinese%20courtyard%20house%20with%20red%20lanterns%20under%20dusk%20sky%2C%20muted%20blue%20and%20amber%20palette%2C%20nostalgic%20cinematic%20mood%2C%20high%20detail&width=600&height=900&seq=tv-poster-011&orientation=portrait",
    description:
      "从三十年代到改革开放，一个普通家族跨越半个世纪的沉浮。时代浪潮翻涌，故人渐行渐远，唯有那片山河始终沉默地见证着一切。",
    updatedAt: "2024-10-02",
    episodeCount: 30,
    updatedTo: 26,
    episodes: [
      { no: 1, title: "故土", summary: "故事从一座北方老城的小院开始，一家人围着灶火说笑。" },
      { no: 2, title: "远行", summary: "家中的长子决定离开故土，去往陌生的远方。" },
      { no: 3, title: "来信", summary: "一封辗转多日的家书，让思念有了落脚的地方。" },
      { no: 4, title: "婚事", summary: "一场简朴的婚礼，承载着两代人的期望。" },
      { no: 5, title: "变局", summary: "时代的浪潮席卷而来，小院里的生活悄然改变。" },
      { no: 6, title: "归来", summary: "离家多年的人终于归来，却发现物是人非。" },
    ],
  },
  {
    id: "t-012",
    title: "甜蜜的信号",
    year: 2024,
    country: "韩国",
    director: "李应福",
    actors: ["金秀贤", "金智媛", "朴叙俊"],
    genres: ["爱情", "喜剧", "都市"],
    rating: 8.1,
    poster:
      "https://readdy.ai/api/search-image?query=romantic%20comedy%20tv%20poster%2C%20two%20smiling%20people%20in%20a%20cozy%20cafe%20with%20soft%20lights%2C%20warm%20amber%20against%20deep%20blue%20window%20night%2C%20sweet%20cinematic%20mood%2C%20high%20detail&width=600&height=900&seq=tv-poster-012&orientation=portrait",
    description:
      "一位冷静理性的大企业主管，与一位热情开朗的电台主播因为一场乌龙事件被迫合作。一个习惯用数据说话，一个相信直觉与缘分，两颗心在电波中悄悄靠近。",
    updatedAt: "2024-10-13",
    episodeCount: 16,
    updatedTo: 8,
    episodes: [
      { no: 1, title: "乌龙直播", summary: "一次误接的电话，让两个人荒唐地登上了同一档节目。" },
      { no: 2, title: "合作协议", summary: "为了各自的目的，他们不得不签下一份尴尬的合作协议。" },
      { no: 3, title: "深夜点歌", summary: "一通深夜来电，让理性的主管第一次认真听完了整首歌。" },
      { no: 4, title: "雨中的伞", summary: "一场突如其来的大雨，让两人共用了一把伞。" },
      { no: 5, title: "误会", summary: "一个被误读的短信，让刚升温的关系骤然降温。" },
      { no: 6, title: "直播告白", summary: "在千万听众的见证下，他终于说出了那句话的前半句。" },
      { no: 7, title: "心跳频率", summary: "数据无法解释的心跳，成了他新的研究课题。" },
      { no: 8, title: "信号", summary: "当两个频率终于对上，甜蜜的信号在电波中响起。" },
    ],
  },
];